<template>
    <FlowEditorComponent />
</template>

<script>
// @ is an alias to /src
import FlowEditorComponent from "@/sections/voiceplus/components/FlowEditorComponent.vue";

export default {
  name: "FlowEditor",
  components: {
    FlowEditorComponent,
  },
};
</script>
